var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    transform: "translate(-795 608)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_15",
    "data-name": "Rettangolo 15",
    width: 82,
    height: 82,
    rx: 26,
    transform: "translate(795 -608)",
    fill: "#f9fafc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "robot-bot-face-svgrepo-com",
    transform: "translate(815 -584.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M33.511,32.185H9.1c-3.37,0-6.1-2.1-6.1-4.7V8.7C3,6.1,5.732,4,9.1,4H33.511c3.37,0,6.1,2.1,6.1,4.7v18.79C39.613,30.082,36.881,32.185,33.511,32.185ZM9.1,7.132A1.847,1.847,0,0,0,7.068,8.7v18.79A1.847,1.847,0,0,0,9.1,29.053H33.511a1.847,1.847,0,0,0,2.034-1.566V8.7a1.847,1.847,0,0,0-2.034-1.566Z",
    transform: "translate(0 1.34)",
    fill: "#489f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M9.9,16.584a1.9,1.9,0,0,1-1.9-1.9V10.9a1.9,1.9,0,0,1,3.792,0v3.792A1.9,1.9,0,0,1,9.9,16.584Z",
    transform: "translate(5.662 6.641)",
    fill: "#489f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M9.9,16.584a1.9,1.9,0,0,1-1.9-1.9V10.9a1.9,1.9,0,0,1,3.792,0v3.792A1.9,1.9,0,0,1,9.9,16.584Z",
    transform: "translate(17.46 6.641)",
    fill: "#489f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M12.447,12.126c-.8,0-1.447-1.245-1.447-2.782V3.782C11,2.245,11.648,1,12.447,1s1.447,1.245,1.447,2.782V9.345C13.894,10.881,13.246,12.126,12.447,12.126Z",
    transform: "translate(8.86 -3.841)",
    fill: "#489f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M9.681,17.855A2,2,0,0,1,8,15.641V11.214A2,2,0,0,1,9.681,9a2,2,0,0,1,1.681,2.214v4.427A2,2,0,0,1,9.681,17.855Z",
    transform: "matrix(0.017, -1, 1, 0.017, 819.507, -576.221)",
    fill: "#489f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M9.9,16.584a1.9,1.9,0,0,1-1.9-1.9V10.9a1.9,1.9,0,0,1,3.792,0v3.792A1.9,1.9,0,0,1,9.9,16.584Z",
    transform: "translate(805.208 -554.815) rotate(-90)",
    fill: "#489f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M9.9,16.584a1.9,1.9,0,0,1-1.9-1.9V10.9a1.9,1.9,0,0,1,3.792,0v3.792A1.9,1.9,0,0,1,9.9,16.584Z",
    transform: "translate(842.766 -554.815) rotate(-90)",
    fill: "#489f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robotIcon.1ceba9030677902b3a3907eca6a73b7b.svg";
export { ForwardRef as ReactComponent };